import axios from 'axios'

export default {
    state: {
        shippingTypes: [],
        paymentMethods: [],
        shippingSelect: '',
        paymentSelect: '',
    },
    mutations: {
        setShippingTypes(state, items) {
            state.shippingTypes = Array.isArray(items) ? items : [];
        },
        setPaymentMethods(state, items) {
            state.paymentMethods = Array.isArray(items) ? items : [];
        },
        setShippingSelect(state, item) {
            state.shippingSelect = item;
        },
        setPaymentSelect(state, item) {
            state.paymentSelect = item;
        },
    },
    actions: {
        async getShippingTypes({ commit }) {
            try {
                const shippingTypes = await axios
                    .post('/darkrogua/babylon/api/Checkout@getShippingTypes')
                    .then(response => response.data)
                commit('setShippingTypes', shippingTypes)
            } catch (e) {
                commit('setShippingTypes', []) // при ошибке гарантируем пустой массив
                commit('setError', e)
                throw e
            }
        },
        async getPaymentMethods({ commit }) {
            try {
                const paymentMethods = await axios
                    .post('/darkrogua/babylon/api/Checkout@getPaymentMethods')
                    .then(response => response.data)
                commit('setPaymentMethods', paymentMethods)
            } catch (e) {
                commit('setPaymentMethods', [])
                commit('setError', e)
                throw e
            }
        },
    },
    getters: {
        shippingTypes: s => Array.isArray(s.shippingTypes) ? s.shippingTypes : [],
        paymentMethods: s => Array.isArray(s.paymentMethods) ? s.paymentMethods : [],
        shippingSelect: s => s.shippingSelect,
        paymentSelect: s => s.paymentSelect,
    }
}
